import { DirectionProvider } from '@radix-ui/react-direction';

import { useDocumentLanguage } from '../../hooks/use-document-language';

export interface DocumentDirectionProviderProps {
  children: React.ReactNode;
}

/**
 * Provides text direction to the entire component tree.
 *
 * This provider does two things:
 * 1. Sets the `lang` and `dir` attributes on `<html>` via `useDocumentLanguage()` — this handles
 *    CSS logical properties, browser text-shaping, and native form controls.
 * 2. Wraps children with Radix UI's `DirectionProvider` — this ensures portaled Radix components
 *    (dropdown menus, dialogs, tooltips, etc.) correctly render in RTL mode, since portals don't
 *    inherit the DOM `dir` attribute.
 *
 * Use this component once in the root layout of each app, wrapping the `<Outlet />`.
 */
export function DocumentDirectionProvider({ children }: DocumentDirectionProviderProps): React.JSX.Element {
  const dir = useDocumentLanguage();

  return <DirectionProvider dir={dir}>{children}</DirectionProvider>;
}
